import React from "react";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { getBrowserTime } from "../../../utils/general";

import {
  Typography,
  ListItem,
  Box,
  IconButton,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ErrorOutline";
import PlayArrow from "@material-ui/icons/PlayArrow";
import { get } from "lodash";
import { updateNotificationMutation } from "../../../graphQL/queries/notifications";
import { useStyles } from "./styles";
import VisionImg from "Assets/images/profile-banner.png";
// import VisionImg from "../../../assets/images/vision-default-image.svg";
import UserProfileWidget from "../../widgets/UserProfileWidget";
import VisionCommentPopover from "../../formControls/Popovers/VisionCommentPopover";
import WordCloudPopover from "../../formControls/Popovers/WordCloudPopover";
import { useTranslation } from "react-i18next";
import { getFileTypeByKey, getUserId } from "../../../utils";
import {
  CREATEDBY_FILENAME,
  CREATEDBY_FIRSTNAME,
  CREATEDBY_LASTNAME,
  MSG_DESCRIPTION,
  MSG_TITLE,
} from "../../../constants/literalConstant";
import { VISION, BOARD } from "../../../constants/routeConstants";
import VideoThumbnail from "react-video-thumbnail";
import { useSetRecoilState } from "recoil";
import { visionNotificationState } from "../../../recoil/Vision/atom";
import { COMPANY_ADMIN, NOTIFICATION_LIST_DATE_TIME } from "../../../constants";
import Auth from "@aws-amplify/auth";
import { useVisionNotification } from "Hooks/layout/useVisionNotification";

const VisionNotificationListItem = ({
  handleClose,
  getUserData,
  notification,
  isReadNotification,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const userId = getUserId();
  const userRole = get(Auth, "user.attributes.custom:role");
  const [MyMutation] = useMutation(updateNotificationMutation);
  const setVisionNotificationState = useSetRecoilState(visionNotificationState);

  const notificationDate = getBrowserTime(
    get(notification, "createdAt", ""),
    NOTIFICATION_LIST_DATE_TIME
  );
const {changeNotification} = useVisionNotification();
  // const changeNotification = (variables, updateType) => {
  //   MyMutation({ variables })
  //     .then(() => {
  //       if (updateType === "isRead") {
  //         isReadNotification();
  //       } else if (updateType === "delete") {
  //         getUserData();
  //       }
  //     })
  //     .catch((error) => console.log(error));
  // };

  const updateNotification = async (notificationItem) => {
    // setVisionNotificationState(notificationItem.visionId);
    if (!notificationItem.Isread) {
      const variables = {
        input: {
          userId,
          id: notificationItem.id,
          Isread: true,
        },
      };
      changeNotification(variables, "isRead");
    }
  };

  const deleteNotification = async (notificationItem) => {
    const variables = {
      input: {
        userId,
        id: notificationItem.id,
        isDeleted: true,
      },
    };
    changeNotification(variables, "delete");
  };

  const getMedia = () => {
    const type = getFileTypeByKey(
      get(notification, "message.documentName", "")
    );
    if (type && type.startsWith("video/")) {
      return (
        <Box className={classes.thumbnail}>
          <VideoThumbnail
            videoUrl={get(notification, "message.documentUrl", "") || VisionImg}
          />
          <span className={classes.playIcon}>
            <PlayArrow />
          </span>
        </Box>
      );
    }
    return (
      <img
        className={classes.visionImg}
        src={get(notification, "message.documentUrl", "") || VisionImg}
        alt="visionimg"
      />
    );
  };

  if (notification.notificationType === "VisionAdded") {
    return (
      <ListItem
        className={
          notification !== null && notification.Isread
            ? classes.readMessage
            : ""
        }
      >
        <ListItemText
          data-testid="list"
          onClick={() => updateNotification(notification)}
        >
          <Box display="flex">
            <UserProfileWidget
              firstName={get(notification, CREATEDBY_FIRSTNAME, "")}
              lastName={get(notification, CREATEDBY_LASTNAME, "")}
              url={get(notification, CREATEDBY_FILENAME, "")}
            />
            <Box width="80%">
              <Box data-testid="box">
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="subtitle2"
                    className={`font-13 truncate-txt ${classes.userName}`}
                  >
                    {get(notification, CREATEDBY_FIRSTNAME, "")}{" "}
                    {get(notification, CREATEDBY_LASTNAME, "")}
                  </Typography>
                  <span className={`${classes.vertDivider} mr5 ml5`}>|</span>
                  <Tooltip title={get(notification, MSG_TITLE, "")}>
                    <Typography
                      variant="body2"
                      className="font-13"
                      noWrap="true"
                    >
                      {get(notification, MSG_TITLE, "")}
                    </Typography>
                  </Tooltip>
                </Box>
                <Box
                  data-testid="box4"
                  onClick={() => {
                    handleClose();
                    setVisionNotificationState(notification.visionId);
                    history.push(`${VISION}${BOARD}`);
                  }}
                >
                  {getMedia()}
                </Box>
                <Typography variant="body2" className="f-light-gray font-12">
                  {notificationDate}
                </Typography>
              </Box>
              <Box className={classes.buttonsLayout}>
                <Box display="flex" alignItems="center">
                  <Box>
                    <IconButton aria-label="Like">
                      <WordCloudPopover
                        visionId={get(notification, "visionId", "")}
                        updateNotification={updateNotification}
                        notification={notification}
                      />
                    </IconButton>
                  </Box>
                  <span className={`${classes.vertDivider} mr5 ml5`}>|</span>
                  <Box>
                    <IconButton aria-label="Comment">
                      <VisionCommentPopover
                        visionId={get(notification, "visionId", "")}
                        updateNotification={updateNotification}
                        notification={notification}
                      />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </ListItemText>
        <Tooltip title="Remove">
          <IconButton
            data-testid="icon"
            aria-label="remove"
            onClick={() => deleteNotification(notification)}
            size="small"
            className={classes.closeIcon}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ListItem>
    );
  }

  if (
    [
      "VisionCommentAdded",
      "VisionReportedToCA",
      "ReportedVisionIgnored",
      "ReportedVisionDeactivated",
      "ReportedVisionReactivated",
    ].includes(notification.notificationType)
  ) {
    return (
      <ListItem
        className={
          notification !== null && notification.Isread
            ? classes.readMessage
            : ""
        }
      >
        <ListItemText
          data-testid="list"
          onClick={() => updateNotification(notification)}
        >
          <Box data-testid="box1" display="flex">
            <UserProfileWidget
              firstName={get(notification, CREATEDBY_FIRSTNAME, "")}
              lastName={get(notification, CREATEDBY_LASTNAME, "")}
              url={get(notification, CREATEDBY_FILENAME, "")}
            />
            <Box width="80%">
              <Box
                data-testid="box7"
                onClick={() => {
                  setVisionNotificationState(notification.visionId);
                  notification.notificationType === "VisionReportedToCA"
                    ? history.push(`${VISION}${BOARD}?isReported=true`)
                    : history.push(`${VISION}${BOARD}`);
                  handleClose();
                }}
              >
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="subtitle2"
                    className={`font-13 truncate-txt ${classes.userName}`}
                  >
                    {get(notification, CREATEDBY_FIRSTNAME, "")}{" "}
                    {get(notification, CREATEDBY_LASTNAME, "")}
                  </Typography>
                  <span className={`${classes.vertDivider} mr5 ml5`}>|</span>
                  <Typography
                    variant="body2"
                    className={`font-13 ${classes.msgTitle}`}
                    noWrap="true"
                  >
                    {get(notification, MSG_TITLE, "")}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  className="f-gray font-13 break-word"
                >
                  {(get(notification, MSG_DESCRIPTION, "") || "").length > 100
                    ? `${get(notification, MSG_DESCRIPTION, "").substring(
                        0,
                        100
                      )}...`
                    : get(notification, MSG_DESCRIPTION, "")}
                </Typography>
                <Typography variant="body2" className="f-light-gray font-12">
                  {notificationDate}
                </Typography>
              </Box>
            </Box>
          </Box>
        </ListItemText>
        <Tooltip title="Remove">
          <IconButton
            data-testid="icon1"
            aria-label="remove"
            onClick={() => deleteNotification(notification)}
            color="primary"
            size="small"
            className={classes.closeIcon}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ListItem>
    );
  }

  if (notification.notificationType === "VisionEncouragementWordAdded") {
    return (
      <ListItem
        className={
          notification !== null && notification.Isread
            ? classes.readMessage
            : ""
        }
      >
        <ListItemText
          data-testid="list"
          onClick={() => updateNotification(notification)}
        >
          <Box data-testid="box2" display="flex">
            <UserProfileWidget
              firstName={get(notification, CREATEDBY_FIRSTNAME, "")}
              lastName={get(notification, CREATEDBY_LASTNAME, "")}
              url={get(notification, CREATEDBY_FILENAME, "")}
            />
            <Box width="80%">
              <Box display="flex" alignItems="center">
                <Typography
                  variant="subtitle2"
                  className={`font-13 truncate-txt ${classes.userName}`}
                >
                  {get(notification, CREATEDBY_FIRSTNAME, "")}{" "}
                  {get(notification, CREATEDBY_LASTNAME, "")}
                </Typography>
                <span className={`${classes.vertDivider} mr5 ml5`}>|</span>
                <Typography variant="body2" className="font-13" noWrap="true">
                  {get(notification, MSG_TITLE, "")}
                </Typography>
              </Box>
              <Box
                data-testid="box5"
                onClick={() => {
                  handleClose();
                  setVisionNotificationState(notification.visionId);
                  history.push(`${VISION}${BOARD}`);
                }}
              >
                <Typography variant="body2" className="f-gray font-13">
                  {`${t("dashboard.visionEncouragementText")} "${get(
                    notification,
                    MSG_DESCRIPTION,
                    ""
                  )}"`}
                </Typography>
              </Box>
              <Typography variant="body2" className="f-light-gray font-12">
                {notificationDate}
              </Typography>
            </Box>
          </Box>
        </ListItemText>
        <Tooltip title="Remove">
          <IconButton
            data-testid="icon2"
            aria-label="remove"
            onClick={() => deleteNotification(notification)}
            color="primary"
            size="small"
            className={classes.closeIcon}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ListItem>
    );
  }

  if (notification.notificationType === "VisionReportedToCreator") {
    return (
      <ListItem
        className={
          notification !== null && notification.Isread
            ? classes.readMessage
            : ""
        }
      >
        <ListItemText
          data-testid="list"
          onClick={() => updateNotification(notification)}
        >
          <Box
            data-testid="box3"
            display="flex"
            onClick={() => {
              handleClose();
              setVisionNotificationState(notification.visionId);
              if (userRole === COMPANY_ADMIN) {
                history.push(`${VISION}${BOARD}?isReported=true`);
              }
            }}
          >
            <span className={classes.reportIcon}>
              <ReportProblemOutlinedIcon />
            </span>
            <Box width="80%">
              <Box display="flex" alignItems="center">
                <Typography variant="body2" className="font-13" noWrap="true">
                  {get(notification, MSG_TITLE, "")}
                </Typography>
              </Box>
              <Typography variant="body2" className="f-gray font-13 break-word">
                {`${get(notification, MSG_DESCRIPTION, "")}"`}
              </Typography>
              <Typography variant="body2" className="f-light-gray font-12">
                {notificationDate}
              </Typography>
            </Box>
          </Box>
        </ListItemText>
        <Tooltip title="Remove">
          <IconButton
            data-testid="icon3"
            aria-label="remove"
            onClick={() => deleteNotification(notification)}
            color="primary"
            size="small"
            className={classes.closeIcon}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ListItem>
    );
  }
};

export default VisionNotificationListItem;
